export default {
    Credenciamento: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "credenciamento"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Credenciamento.js
// module id = AelI
// module chunks = 16